import { Asset } from '@marketertechnologies/property-picker';

import { queryClient } from '~/utils/queryClient';
import requestInstance from '~/utils/requestInstance';
import { splitEvery } from '~/utils/splitEvery';

type Response = Record<string, Asset>;

type FloorplanAsset = Asset & { unit_uuid: string };
type GetFloorplansPreviewDataArgs = {
  projectUuid?: string;
  unitsUuidList?: string[];
};

export const getFloorplansPreviewData = async ({
  projectUuid,
  unitsUuidList,
}: GetFloorplansPreviewDataArgs): Promise<Response> => {
  if (!projectUuid) {
    return Promise.reject(`Missing projectUuid, ${projectUuid}`);
  }

  return queryClient.fetchQuery({
    queryKey: ['floorplans-preview', projectUuid, unitsUuidList],
    queryFn: async (): Promise<Record<string, Asset>> => {
      const batches = splitEvery(150, [...new Set(unitsUuidList)].sort());

      const fetchBatchData = async (batch: string[]) => {
        const response = await requestInstance.get(
          `/property_pickers/${projectUuid}/unit_floorplan_thumbnails`,
          {
            params: {
              'units[]': batch,
            },
          },
        );

        return response.data;
      };

      const results = await Promise.all(batches.map(fetchBatchData));

      return results
        .flat()
        .filter((item: FloorplanAsset) => Boolean(item.uuid))
        .reduce(
          (acc: Record<string, Asset>, item: FloorplanAsset) => ({
            ...acc,
            [item.unit_uuid]: item,
          }),
          {},
        );
    },
  });
};
